/**
 * Users API service
 * Handles user-related API calls
 */

import api from './api'

const usersService = {
  /**
   * Search users by email, first name, or last name
   * @param {string} query - Search query
   * @returns {Promise} List of matching users (max 10)
   */
  searchUsers: async (query) => {
    if (!query || query.trim() === '') {
      return []
    }

    const response = await api.get('/users/search/', {
      params: { q: query.trim() },
    })
    return response.data
  },

  /**
   * List all active users (admin only)
   * @returns {Promise<Array<{id: number, email: string, first_name: string, last_name: string, last_login: string}>>}
   */
  listUsers: async () => {
    const response = await api.get('/users/')
    return response.data
  },

  /**
   * Disable a user account and blacklist their tokens (admin only)
   * @param {number} userId - ID of the user to disable
   * @returns {Promise<{message: string, tokens_blacklisted: number, user: object}>}
   */
  disableUser: async (userId) => {
    const response = await api.post(`/users/${userId}/disable/`)
    return response.data
  },

  /**
   * Promote a standard user to admin (admin only)
   * @param {number} userId - ID of the user to promote
   * @returns {Promise<{message: string, user: object}>}
   */
  promoteUser: async (userId) => {
    const response = await api.post(`/users/${userId}/promote/`)
    return response.data
  },

  /**
   * Demote an admin user to standard user (admin only)
   * @param {number} userId - ID of the user to demote
   * @returns {Promise<{message: string, user: object}>}
   */
  demoteUser: async (userId) => {
    const response = await api.post(`/users/${userId}/demote/`)
    return response.data
  },
}

export default usersService
